/* Project Import will be here */
import {
    getSchemeList,
    schemeProductDetailApi
} from "services/promotions";
import { getBannersList } from "reducers/home/banners";
import { getErrorObject } from "../utilities/utils";
import { mergeAndNormalizeProducts, types as productTypes, initialFilterState } from "./products";
import { ISchemeProductDetailParams, ISchemeListParams } from "models/promotionModels";
import { GAViewPromotion } from "hooks/googleAnalyticsHooks";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    PROMOTION_LIST_REQUEST: "promotion/RequestPromotionList",
    PROMOTION_DETAILS_REQUEST: "promotion/RequestPromotionDetails",
    PROMOTION_SUCCESS: "promotion/PromotionSuccess",
    PROMOTION_FAILURE: "promotion/PromotionFailure",
    SHOW_OR_HIDE_PROMO_DETAILS: "promotion/ShowOrHidePromoDetails",
    PROMOTION_LIST_NEXT_PAGE_REQUEST: "promotion/PROMOTION_LIST_NEXT_PAGE_REQUEST"
};

/* Initial product filter state values */
const initialSchemeFilterState: ISchemeListParams = {
    Page: 1,
    Ids: [],
    FilterLevelCode: "",
    NeedFOC: false
};

const initialPromoDetailsState = {
    filter: initialSchemeFilterState,
    isPromoListLoading: false,
    isPromoDetailsLoading: false,
    promotionList: [],
    count: 0,
    totalCount: 0,
    noOfItemsReceived: 0,
    IsShowShowMoreProductButton: true,
    selectedPromotionDetails: {},
    isShowPromoDetailsModal: false,
    error: null
};

const initialPromoListState = {
    filter: initialSchemeFilterState,
    isPromoListLoading: false,
    isPromoDetailsLoading: false,
    promotionList: [],
    count: 0,
    totalCount: 0,
    noOfItemsReceived: 0,
    IsShowShowMoreProductButton: true,
    selectedPromotionDetails: {},
    isShowPromoDetailsModal: false,
    error: null
};

const initialState = {
    list: { ...initialPromoListState },
    details: { ...initialPromoDetailsState }
};

export const promotions = (state = initialState, action) => {
    switch (action.type) {
        case types.PROMOTION_LIST_REQUEST:
            return {
                ...state,
                [action.target]: {
                    ...state[action.target],
                    promotionList: [],
                    isPromoListLoading: true,
                    IsShowShowMoreProductButton: true,
                    count: 0,
                    totalCount: 0,
                    noOfItemsReceived: 0,
                    filter: {
                        ...state[action.target].filter,
                        ...action.payload
                    }
                }
            };
        case types.PROMOTION_DETAILS_REQUEST:
            return {
                ...state,
                details: { ...state.details, isPromoDetailsLoading: true },
                list: { ...state.list, isPromoDetailsLoading: true }
            };
        case types.PROMOTION_SUCCESS:
            return {
                ...state,
                [action.target]: { ...state[action.target], ...action.payload }
            };
        case types.PROMOTION_LIST_NEXT_PAGE_REQUEST:
            return {
                ...state,
                list: {
                    ...state.list,
                    filter: {
                        ...state.list.filter,
                        Page: action.payload.nextPage
                    },
                    error: null,
                    isPromoListLoading: true,
                    IsShowShowMoreProductButton: true
                }
            };
        case types.SHOW_OR_HIDE_PROMO_DETAILS:
            return {
                ...state,
                list: { ...state.list, ...action.payload },
                details: { ...state.details, ...action.payload },
                error: null
            };
        case types.PROMOTION_FAILURE:
            return {
                ...state,
                list: {
                    ...initialPromoListState,
                    selectedPromotionDetails: {},
                    isPromoListLoading: false,
                    isPromoDetailsLoading: false,
                    IsShowShowMoreProductButton: false,
                    error: action.payload ? action.payload.error : null
                },
                details: {
                    ...initialPromoDetailsState, selectedPromotionDetails: {},
                    isPromoListLoading: false,
                    isPromoDetailsLoading: false,
                    IsShowShowMoreProductButton: false,
                    error: action.payload ? action.payload.error : null
                }
            };
        default:
            return state;
    }
};

/* Get scheme list */
export const getSchemes = (inputObj) => {
    return async (dispatch, getState) => {
        /* Request for promotion list and assign filter object */
        await dispatch({ type: types.PROMOTION_LIST_REQUEST, target: inputObj.requestPageType === Constants.PRODUCT_DETAILS ? "details" : "list", payload: inputObj });

        try {
            const response = await getSchemeList(inputObj.requestPageType === Constants.PRODUCT_DETAILS ? getState().promotions.details.filter : getState().promotions.list.filter);

            const payloadData = {
                filter: inputObj.requestPageType === Constants.PRODUCT_DETAILS ? getState().promotions.details.filter : getState().promotions.list.filter,
                promotionList: response.data.Data,
                isPromoListLoading: false,
                count: response.data.Count,
                totalCount: response.data.TotalCount,
                noOfItemsReceived: response.data.Data.length,
                IsShowShowMoreProductButton: true,
                error: null
            };

            if (inputObj.requestPageType === Constants.PRODUCT_DETAILS) {
                dispatch({
                    type: types.PROMOTION_SUCCESS,
                    target: "details",
                    payload: payloadData
                });
            } else {
                dispatch({
                    type: types.PROMOTION_SUCCESS,
                    target: "list",
                    payload: payloadData
                });
            }
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.PROMOTION_FAILURE,
                payload: { error: message, promotionList: [] }
            });
        }
    };
};

/* promotion pagination */
export const getNextPageSchemes = (nextPage) => {
    return async (dispatch, getState) => {
        /* Update the next page number before API request */
        await dispatch({
            type: types.PROMOTION_LIST_NEXT_PAGE_REQUEST,
            payload: { nextPage }
        });

        try {
            const response = await getSchemeList(getState().promotions.list.filter);
            const responseSchemeList = response.data.Data;

            /* If no data available for the next page.no need to do anything */
            if (responseSchemeList.length > 0) {
                const oldSchemes = getState().promotions.list;
                const newState = {
                    promotionList: [...oldSchemes.promotionList, ...responseSchemeList],
                    count: response.data.Count,
                    totalCount: response.data.TotalCount,
                    isPromoListLoading: false,
                    noOfItemsReceived: oldSchemes.noOfItemsReceived + responseSchemeList.length
                };

                dispatch({
                    type: types.PROMOTION_SUCCESS,
                    target: "list",
                    payload: newState
                });
            }
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({ type: types.PROMOTION_FAILURE, payload: { error: message } });
        }
    };
};

/* Get scheme details information */
export const getSchemeDetail = ({ schemeId, needProducts = false, pageType = '' }) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.PROMOTION_DETAILS_REQUEST });

        /* If need products is true then initiate the ProductRequest */
        if (needProducts) {
            dispatch({
                type: productTypes.PRODUCTS_REQUEST,
                payload: { filter: { ...initialFilterState } }
            });
        }
        try {
            const requestObject: ISchemeProductDetailParams = {
                Ids: [schemeId],
                NeedProduct: true,
                Sorting: getState().appSettings.defaultProductSorting,
                Page: 1,
                BannerActive: pageType === Constants.HOME_PAGE_SECTIONS_BANNER
            };
            const response = await schemeProductDetailApi(requestObject);
            const schemeDetail = response.data.Data;

            const payloadData = {
                selectedPromotionDetails: schemeDetail,
                isPromoDetailsLoading: false
            }

            if (pageType === Constants.PRODUCT_DETAILS) {
                dispatch({
                    type: types.PROMOTION_SUCCESS,
                    target: "details",
                    payload: payloadData
                });
            } else {
                dispatch({
                    type: types.PROMOTION_SUCCESS,
                    target: "list",
                    payload: payloadData
                });
            }

            /* GA - Track scheme selection in google analytics */
            if (window.isEnableGA)
                GAViewPromotion(schemeDetail);

            /* If need products is true then assign the product list to Product reducer */
            if (needProducts) {
                dispatch(mergeAndNormalizeProducts(schemeDetail.Products, schemeDetail.Count, schemeDetail.TotalCount));
            }
        } catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.PROMOTION_FAILURE,
                payload: { error: message }
            });

            /* Reload the banner if details not available */
            await dispatch(getBannersList());
        }
    };
};

export const openOrClosePromoDetailsModal = (isShow) => {
    return async dispatch => {
        dispatch({
            type: types.SHOW_OR_HIDE_PROMO_DETAILS,
            payload: { isShowPromoDetailsModal: isShow }
        });
    };
};